// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { DEFAULT_NUMBER_ZERO, EMPTY_STRING } from '~/utils/constants/common';
import { IFormPO } from '~/utils/interface/po';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      poNumber: yup.string().trim().optional(),
      receiptNumber: yup.string().trim().optional(),
      total: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
      products: yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().trim().optional().nullable(),
            quantity: yup.number().optional(),
            cost: yup.number().optional(),
            totalCost: yup.number().optional(),
          })
        )
        .min(0)
        .required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};

export const defaultValueProductPO = {
  cost: 0,
  name: EMPTY_STRING,
  quantity: 0,
  totalCost: 0,
};

export const defaultValuesForm: IFormPO = {
  poNumber: EMPTY_STRING,
  products: [defaultValueProductPO],
  receiptNumber: EMPTY_STRING,
  total: DEFAULT_NUMBER_ZERO,
  jobId: EMPTY_STRING,
};
